exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warning-modal-container[data-v-fb8e173e]{display:flex;flex-direction:column;justify-content:start;width:90%;height:300px}.warning-modal-container .message[data-v-fb8e173e]{margin:1.3em;background-color:transparent;font-size:18px;font-weight:700;text-align:center}.warning-modal-container .modal-action-wrapper[data-v-fb8e173e]{display:flex;justify-content:center;margin:7px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fb8e173e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checkout/WarningModal.vue
// module id = kbbA
// module chunks = 18